// Run before application modules/diagnostics. Provider callback data is never payment proof.
const safeReference = value => typeof value === 'string' && /^[a-zA-Z0-9_.:-]{1,100}$/.test(value) ? value : '';
export function capturePaymentReturn(browser = typeof window === 'undefined' ? null : window) {
  if (!browser || browser.location.pathname !== '/payments/return') return;
  const reference = safeReference(new URLSearchParams(browser.location.search).get('reference'));
  browser.history.replaceState(browser.history.state, '', reference ? `/?paymentReference=${encodeURIComponent(reference)}` : '/?paymentReturn=1');
}
export function getPaymentReturnReference() {
  if (typeof window === 'undefined') return '';
  return safeReference(new URLSearchParams(window.location.search).get('paymentReference'));
}
export function hasPaymentReturn() {
  return typeof window !== 'undefined' && (Boolean(getPaymentReturnReference()) || new URLSearchParams(window.location.search).get('paymentReturn') === '1');
}
export function clearPaymentReturn() {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  url.searchParams.delete('paymentReference'); url.searchParams.delete('paymentReturn');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
capturePaymentReturn();
